import { createSelector } from '@reduxjs/toolkit'
import { selectUnitPrices } from '../slices/unitPrices.slice'

export const selectHangingTypeOptions = createSelector(
  [selectUnitPrices],
  unitPrices => {
    return Array.from(new Set(
      unitPrices
        .map(u => u.hangingType)
        .filter(Boolean),
    ))
  },
)